import React from 'react';
import classNames from 'classnames';
import './PasswordValidation.pcss';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';

export type Props = {
  text: string;
  className?: string;
  childClassName?: string;
  error?: boolean;
  hideWithoutError?: boolean;
  withIcon?: boolean;
};

export const PasswordValidation = ({
  text,
  className,
  error,
  childClassName,
  hideWithoutError,
  withIcon,
}: Props) => {
  if (!error && hideWithoutError) {
    return <></>;
  }

  return (
    <div className={classNames('password-validation__item-wrapper', className)}>
      {withIcon && (
        <>
          {error ? (
            <ExclamationCircleOutlined className="password-validation__error_icon" />
          ) : (
            <CheckCircleOutlined className="password-validation__check_icon" />
          )}
        </>
      )}
      <span
        className={classNames(
          'password-validation__text-item',
          error ? 'text-item-error' : '',
          childClassName,
        )}
      >
        {text}
      </span>
    </div>
  );
};
